import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import { getFetchOptions } from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";

const EditClass = () => {
  const [classYear, setClassYear] = useState(null);
  const [section, setSection] = useState(null);
  const currentMonth = new Date().getMonth();
  const [schoolYear, setSchoolYear] = useState(
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`
  );
  const [schoolId, setSchoolId] = useState(null);
  const [schools, setSchools] = useState([]);
  const classId = window.location.pathname.split("/").pop();

  const breadcrumb = {
    current_section: "Nuovo",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione classi", route_name: null, params: [] },
      { name: "Nuovo", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchools(result.return.scuola);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchClass = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola/classe?idclasse=${classId}`,
          fetchOptions
        );
        const result = await response.json();
        setClassYear(result.return.classe[0].classe);
        setSection(result.return.classe[0].sezione);
        setSchoolYear(result.return.classe[0].annoscolastico);
        setSchoolId(result.return.classe[0].idscuola);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchools();
    fetchClass();
  }, []);

  const handleSave = () => {
    if (!classYear) {
      alert("Il campo 'Classe' è obbligatorio.");
      return;
    }
    if (!section) {
      alert("Il campo 'Sezione' è obbligatorio.");
      return;
    }
    if (!schoolYear) {
      alert("Il campo 'Anno scolastico' è obbligatorio.");
      return;
    }
    if (classYear < 1 || classYear > 5) {
      alert("Il campo 'Classe' deve essere un numero tra 1 e 5.");
      return;
    }
    let formData = {};
    formData["id"] = classId;
    formData["idscuola"] = schoolId;
    formData["classe"] = classYear;
    formData["sezione"] = section;
    formData["annoscolastico"] = schoolYear;
    formData["insegnanterif"] = 1; //TEMP

    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      formData,
      "PUT"
    );
    fetch(`${axios.defaults.baseURL}/scuola/classe`, fetchOptions).then(() => {
      window.location = "/classes/" + schoolId;
    });
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />
      <a href="/classes">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista classi
        </button>
      </a>
      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      {/* General Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>
            Nuovo -{" "}
            {schools.find((school) => school.id === schoolId)?.denomistituto}
          </span>
        </div>
        <div className="card-body">
          <form id="classForm">
            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="classe">
                  Classe <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="classe"
                  name="classe"
                  label="classe"
                  type="number"
                  value={classYear || ""}
                  min={1}
                  max={5}
                  onChange={(e) => setClassYear(e.target.value)}
                  required
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="sezione">
                  Sezione <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="sezione"
                  name="sezione"
                  label="sezione"
                  value={section || ""}
                  onChange={(e) => setSection(e.target.value)}
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="schoolYear">
                  Anno scolastico <b>*</b>
                </label>
                <select
                  className="form-control"
                  id="annoscolastico"
                  name="annoscolastico"
                  value={
                    schoolYear ||
                    `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
                  }
                  onChange={(e) => setSchoolYear(e.target.value)}
                  readOnly
                  disabled
                >
                  <option value="">Scegli anno scolastico...</option>
                  {Array.from({ length: 10 }).map((_, idx) => {
                    const year = new Date().getFullYear() - 5 + idx;
                    const option = (
                      <option key={year} value={`${year}${year + 1}`}>
                        {`${year}/${year + 1}`}
                      </option>
                    );
                    return option;
                  })}
                </select>
              </div>
            </div>
            <div className="saveButtonContainer">
              <button
                type="button"
                className="btn btn-success text-uppercase"
                onClick={handleSave}
              >
                <i className="fa fa-save"></i> Salva
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditClass;
